var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"opening"},[_c('div',{staticClass:"main"},[_c('h3',{staticClass:"title"},[_vm._v("立即免费开通 专属活动店铺")]),_c('div',{staticClass:"btn",on:{"click":_vm.registerShow}},[_vm._v("免费开通")])])])}
var staticRenderFns = []

export { render, staticRenderFns }